<template>
  <div class="account-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="账号姓名" prop="staff">
        <div>
          <a-button type="primary" @click="showModal">选择</a-button>
        </div>
        <div>
          <a-tag class="large" closable @close.prevent="delStaff(index)" v-for="(value, index) in form.staff" :key="index">{{value.name}}</a-tag>
        </div>
      </a-form-model-item>
      <a-form-model-item label="账号类型" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio :value="1">平台</a-radio>
          <a-radio :value="0">社区</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="管理角色" prop="role">
        <a-select v-model="form.role" placeholder="请选择管理角色" mode="multiple">
          <a-select-option :value="value.id" v-for="(value, index) in roleOptions" :key="index">{{value.title}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="管理范围" prop="range" v-if="!form.type">
        <a-select v-model="form.range" placeholder="请选择管理范围" mode="multiple">
          <a-select-option :value="value.id" v-for="(value, index) in rangeOptions" :key="index">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
    <a-modal :title="modal.title" v-model="modal.show" @ok="confirmModal" destroy-on-close width="60%" centered>
      <tree-select v-model="modal.staff" :data="tree.data" :params="tree.params"></tree-select>
    </a-modal>
  </div>
</template>

<script>
  import OrganizationService from '@/io/organization.js';
  import CommunityService from '@/io/community.js';
  import RoleService from '@/io/role.js';
  import AccountService from '@/io/account.js';

  export default {
    name: 'AccountInfo',
    data() {
      return {
        id: this.$route.params.id,
        tree: {
          data: [],
          params: {
            children: 'children',
            title: 'name',
            key: 'backupId'
          }
        },
        modal: {
          title: '选择人员',
          show: false,
          staff: []
        },
        rangeOptions: [],
        roleOptions: [],
        form: {
          staff: [],
          type: null,
          role: [],
          range: []
        },
        rules: {
          staff: [
            {
              required: true,
              message: '请选择人员'
            }
          ],
          type: [
            {
              required: true,
              message: '请选择账号类型'
            }
          ],
          role: [
            {
              required: true,
              message: '请选择管理角色'
            }
          ],
          range: [
            {
              required: true,
              message: '请选择管理范围'
            }
          ]
        }
      }
    },
    mounted () {
      Promise.all([
        this.initTreeData(),
        this.initRangeOptions()
      ]).then(() => {
        this.initPage();
      });
    },
    watch: {
      'form.type': {
        handler(newValue, oldValue) {
          if (typeof newValue === 'number') {
            this.initRoleOptions();
          }
        },
        immediate: true
      }
    },
    methods: {
      confirmModal() {
        this.modal.show = false;
        this.form.staff = this.$createNewVariable(this.modal.staff);
      },
      showModal() {
        this.modal.show = true;
        this.modal.staff = this.$createNewVariable(this.form.staff);
      },
      delStaff(index) {
        this.form.staff.splice(index, 1);
      },
      initPage() {
        if (this.id) {
          AccountService.info(this.id).then(res => {
            this.$depthSearchTree(node => {
              if (node[this.tree.params.key] === `s-${res.staff_id}`) {
                this.form.staff = [{
                  ...node,
                  backupId: `s-${node.id}`
                }];
              }
            }, this.tree.data);
            this.form.type = res.is_platform_role;
            this.form.role = res.roles.map(val => val.id);
            this.form.range = res.userCommunity.map(val => val.community_id);
          }).catch(err => {});
        }
      },
      initTreeData() {
        return OrganizationService.companyStaffList().then(res => {
          this.$depthSearchTree(node => {
            if (node.type === 1) {
              node.disabled = true;
              node.backupId = `d-${node.id}`;
            } else {
              node.backupId = `s-${node.id}`;
            }
          }, res);
          this.tree.data = res;
        }).catch(err => {});
      },
      initRangeOptions() {
        return CommunityService.listPage().then(res => {
          this.rangeOptions = res;
        }).catch(err => {});
      },
      initRoleOptions() {
        return RoleService.listPage(null, this.form.type).then(res => {
          this.roleOptions = res;
        }).catch(err => {});
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            AccountService.edit(
              this.id,
              this.form.staff[0].id,
              this.form.type,
              this.form.role,
              this.form.range
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          } else {
            AccountService.add(
              this.form.staff[0].id,
              this.form.type,
              this.form.role,
              this.form.range
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          }
        });
      },
      cancel() {
        this.$router.push('/platform/account_manage');
      }
    },
  }
</script>

<style lang="less" scoped>

</style>